import React, { ReactNode } from "react";
import { FontStyles } from "../utils/font-styles.ts";
import { cn } from "../utils/cn.ts";
import { AuthSectionLayout } from "./auth-section-layout.tsx";

interface UserScreenProps {
  headerText: string;
  image?: string;
  dismissible: boolean;
  padding?: string;
  children: ReactNode;
}

const iconContainerStyle = "absolute top-0 right-0 pt-4 pr-5 items-center cursor-pointer";
const closeIconStyle = "text-2xl fa-sharp fa-solid fa-xmark";
const headerStyle = `font-bold text-center ${FontStyles.h3} px-4.5 pt-5 md:pt-7.5 md:px-7.5`;

export const UserScreen: React.FC<UserScreenProps> = ({ image, headerText, dismissible, children }) => (
  <AuthSectionLayout outerContainerClassName="bg-cloud">
    <div
      className={cn(
        "flex rounded-lg shadow-2xl max-w-full mx-auto",
        image && "md:w-[720px] md:max-w-[720px] lg:max-w-[900px] lg:w-[900px]",
        !image && "sm:w-[380px] md:w-[460px] lg:w-[540px]",
        "border border-neutral-200 overflow-hidden",
      )}
    >
      {image && (
        <div
          className="bg-cover bg-neutral-white bg-center bg-o-repeat rounded-tl-lg rounded-bl-lg hidden md:block flex-grow"
          style={{ backgroundImage: `url(${image})` }}
        ></div>
      )}
      <div className="bg-neutral-white rounded-tl-lg rounded-tr-lg rounded-bl-lg rounded-br-lg flex-none w-full sm:rounded-tl-none sm:rounded-bl-none sm:w-[380px] md:w-[460px] lg:w-[540px]">
        <div className="flex flex-col relative">
          {dismissible && (
            <button className={iconContainerStyle}>
              <i className={closeIconStyle} />
            </button>
          )}
          <h3 className={headerStyle}>{headerText}</h3>
          {children}
        </div>
      </div>
    </div>
  </AuthSectionLayout>
);
